import React from 'react';
import styled from '@emotion/styled';
import { transparentize } from 'polished';
import Section from '../layout/section';

const Container = styled.footer({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  padding: `12px`,
  marginBottom: `30px`,
  fontSize: 14
});

const FooterNav = styled.nav({
  marginTop: `30px`,
  textAlign: 'center',
  a: {
    margin: '0 12px',
    textDecoration: 'none',
    ':hover': {
      textDecoration: 'underline'
    }
  }
});

const FooterNavLinks = styled.div({
  marginTop: 4
});

const Disclaimer = styled.span(props => ({
  color: transparentize(0.5, props.theme.text)
}));

const Footer = ({ children }) => {
  return (
    <Container>
      <Section transparent>
        {children}
        <FooterNav>
          <Disclaimer>
            Game content and materials are trademarks and copyrights of their respective publisher
            and its licensors. All rights reserved. GamerHub is not affiliated with any game
            publisher except for Gamelynx, Inc.
          </Disclaimer>
          <FooterNavLinks>
            <a href="/privacy-policy/">Privacy</a>
            <span>/</span>
            <a href="/terms-of-use/">Terms</a>
            <span>/</span>
            <a href="mailto:hello@gamerhub.gg">Contact</a>
            <span>/</span>
            <span data-ccpa-link="1"></span>
          </FooterNavLinks>
        </FooterNav>
      </Section>
    </Container>
  );
};

export default Footer;
